import { render } from "./GrupoSelectDialog.vue?vue&type=template&id=192d5b12"
import script from "./GrupoSelectDialog.vue?vue&type=script&lang=js"
export * from "./GrupoSelectDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__